// window-doors series images
const WINDOWS_BASE_URL =
  "https://hlineweb-f6dwh8btedejg7fz.z03.azurefd.net//hlinefiles/HLineWeb/Projects/assets/products/windows/series/";

export const HL_IMPERIAL_MINIMAL_SYSTEM_1 = `${WINDOWS_BASE_URL}HL IMPERIAL MINIMAL SYSTEM (1).jpg`;
export const HL_VISTA_MINIMAL_SYSTEM_1 = `${WINDOWS_BASE_URL}HL VISTA MINIMAL SYSTEM (1).jpg`;
export const HL_VISTA_MINIMAL_SYSTEM_2 = `${WINDOWS_BASE_URL}HL VISTA MINIMAL SYSTEM (2).jpg`;
export const HL_ELITE_1 = `${WINDOWS_BASE_URL}HL ELITE (1).jpg`;
export const HL_ELITE_2 = `${WINDOWS_BASE_URL}HL ELITE (2).jpg`;
export const HL_ULTRA_MINIMAL_1 = `${WINDOWS_BASE_URL}HL ULTRA MINIMAL SYSTEM (1).jpg`;
export const HL_ULTRA_MINIMAL_2 = `${WINDOWS_BASE_URL}HL ULTRA MINIMAL SYSTEM (2).jpg`;
export const HL_ULTRA_MINIMAL_3 = `${WINDOWS_BASE_URL}HL ULTRA MINIMAL SYSTEM (3).jpg`;
export const HL_ULTRA_MINIMAL_4 = `${WINDOWS_BASE_URL}HL ULTRA MINIMAL SYSTEM (4).png`;
export const HL_RETRO_GULF_SYSTEM_1 = `${WINDOWS_BASE_URL}HL RETRO GULF SYSTEM (1).jpg`;
export const HL_RETRO_GULF_SYSTEM_2 = `${WINDOWS_BASE_URL}HL RETRO GULF SYSTEM (2).jpg`;
export const HL_ECO_GULF_SYSTEM_1 = `${WINDOWS_BASE_URL}HL ECO GULF SYSTEM (1).jpg`;
export const HL_ECO_GULF_SYSTEM_2 = `${WINDOWS_BASE_URL}HL ECO GULF SYSTEM (2).jpg`;
export const HL_50_CASEMENT_DOOR_1 = `${WINDOWS_BASE_URL}HL 50 CASEMENT DOOR.jpg`;
export const HL_50_CASEMENT_DOOR_2 = `${WINDOWS_BASE_URL}HL 50 CASEMENT DOOR (2).jpg`;
export const HL_40_CASEMENT_DOOR_1 = `${WINDOWS_BASE_URL}HL 40 CASEMENT WINDOW.png`;
export const HL_40_CASEMENT_DOOR_2 = `${WINDOWS_BASE_URL}HL 40 CASEMENT WINDOW (2).jpg`;
export const HL_2560_SLIM_PARTITION = `${WINDOWS_BASE_URL}2560 SLIM PARTITION.jpg`;

//louvers series images
const LOUVER_BASE_URL =
  "https://hlineweb-f6dwh8btedejg7fz.z03.azurefd.net//hlinefiles/HLineWeb/Projects/assets/products/louvers/series/";

export const LINEAR_84C = `${LOUVER_BASE_URL}LINEAR_84C.png`;
export const LINEAR_100C = `${LOUVER_BASE_URL}LINEAR_100C.png`;
export const LINEAR_84R_1 = `${LOUVER_BASE_URL}LINEAR_84R_1.png`;
export const LINEAR_84R_2 = `${LOUVER_BASE_URL}LINEAR_84R_2.png`;
export const U_SHAPE = `${LOUVER_BASE_URL}U_SHAPE.png`;
export const V_SHAPE_1 = `${LOUVER_BASE_URL}V_SHAPE_1.jpg`;
export const V_SHAPE_2 = `${LOUVER_BASE_URL}V_SHAPE_2.png`;
export const V_SHAPE_3 = `${LOUVER_BASE_URL}V_SHAPE_3.png`;
export const V_SHAPE_4 = `${LOUVER_BASE_URL}V_SHAPE_4.png`;
export const ROUND_BUFFULE = `${LOUVER_BASE_URL}ROUND_BUFFULE.png`;
export const OPEN_CELL = `${LOUVER_BASE_URL}OPEN_CELL.png`;
export const SUN_lOUVERS = `${LOUVER_BASE_URL}SUN_lOUVERS.png`;
